export default class NetworkOfflineError extends Error {
    constructor(message = 'Preventing sending a request due to offline mode', ...args) {
        super(...args);
        this.message = message;
    }
}
